/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "VerifyShippingAddressResponse": {
            "nested": {
              "CorrectedField": {
                "values": {
                  "UNKNOWN_FIELD": 0,
                  "POSTAL_CODE": 1,
                  "LOCALITY": 2,
                  "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                  "ADDRESS_LINE_1": 4,
                  "ADDRESS_LINE_2": 5
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse?.nested?.CorrectedField) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE VerifyShippingAddressResponse @ squareup/solidshop/addressVerification/service.proto at 25:1
 */
export const VerifyShippingAddressResponse = {};
/**
 * Which fields were corrected in the corrected address
 *
 * SOURCE CorrectedField @ squareup/solidshop/addressVerification/service.proto at 67:3
 */
VerifyShippingAddressResponse.CorrectedField = $root.lookupEnum('squareup.solidshop.VerifyShippingAddressResponse.CorrectedField').values;
